import React from 'react';
import { useBooking } from '../context/BookingContext';
import { BranchSelection } from './BranchSelection';
import { ServiceSelection } from './ServiceSelection';
import { StylistSelection } from './StylistSelection';
import { DateTimeSelection } from './DateTimeSelection';
import { BookingForm } from './BookingForm';
import { BookingConfirmation } from './BookingConfirmation';
import { CheckIcon } from 'lucide-react';
export const BookingSteps = () => {
  const {
    booking
  } = useBooking();
  const {
    step
  } = booking;
  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <BranchSelection data-id="element-75" />;
      case 2:
        return <ServiceSelection data-id="element-76" />;
      case 3:
        return <StylistSelection data-id="element-77" />;
      case 4:
        return <DateTimeSelection data-id="element-78" />;
      case 5:
        return <BookingForm data-id="element-79" />;
      case 6:
        return <BookingConfirmation data-id="element-80" />;
      default:
        return <BranchSelection data-id="element-81" />;
    }
  };
  return <div className="bg-[#2A1E1E] rounded-lg shadow-lg shadow-[#1A1212]/50 p-6 mb-8 border border-[#3B2A2A]" data-id="element-82">
      <div className="mb-8" data-id="element-83">
        <h2 className="text-2xl font-serif text-center text-[#D6B88E] mb-6" data-id="element-84">
          Book Your Appointment
        </h2>
        <div className="flex justify-between items-center relative" data-id="element-85">
          {[1, 2, 3, 4, 5, 6].map(stepNumber => <div key={stepNumber} className="flex flex-col items-center relative z-10" data-id="element-86">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${step >= stepNumber ? 'bg-[#D6B88E] text-[#2A1E1E]' : 'bg-[#3B2A2A] text-[#8A7A6A]'}`} data-id="element-87">
                {step > stepNumber ? <CheckIcon className="w-5 h-5" data-id="element-88" /> : stepNumber}
              </div>
              <div className="text-xs mt-2 text-[#E7D7BC] font-medium" data-id="element-89">
                {stepNumber === 1 && 'Location'}
                {stepNumber === 2 && 'Services'}
                {stepNumber === 3 && 'Stylist'}
                {stepNumber === 4 && 'Date & Time'}
                {stepNumber === 5 && 'Your Details'}
                {stepNumber === 6 && 'Confirmation'}
              </div>
            </div>)}
          <div className="absolute top-5 h-0.5 w-full bg-[#3B2A2A] -z-0" data-id="element-90"></div>
          <div className="absolute top-5 h-0.5 bg-[#D6B88E] -z-0" style={{
          width: `${(step - 1) * 20}%`
        }} data-id="element-91"></div>
        </div>
      </div>
      {renderStepContent()}
    </div>;
};